/** 后台列表统一分页配置 */
export const DEFAULT_PAGE_SIZE = 30

export const PAGE_SIZE_OPTIONS = [30, 50, 80, 100]

export function createPaginationState(pageSize = DEFAULT_PAGE_SIZE) {
  return {
    page: 1,
    pageSize,
    total: 0
  }
}
